export default "__VITE_ASSET__603c7c90__"